import { PlaceholderPage } from "../../common/placeholder-page"
import { BarChart3 } from 'lucide-react'
 
interface ReportsProps {
  sidebarOpen?: boolean
}

export default function Reports({sidebarOpen }: ReportsProps) {
  return <PlaceholderPage title="Reports" icon={<BarChart3 className="h-6 w-6" />}  />
}
